// Small swipeable photo gallery (Just launched spotlight, snippets/latest-launch.liquid):
// arrows scroll one photo at a time, and the dots and disabled arrows follow the scroll position.
class SLaunchGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const track = this.querySelector('[data-gallery-track]');
    if (!track) return;

    const step = (direction) => {
      const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      track.scrollBy({ left: direction * rtl * track.clientWidth, behavior });
    };
    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => step(-1), { signal });
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => step(1), { signal });
    track.addEventListener('scroll', () => this.#sync(track), { signal, passive: true });
    this.#sync(track);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync(track) {
    const width = track.clientWidth || 1;
    const index = Math.round(Math.abs(track.scrollLeft) / width);
    const count = track.children.length;
    this.querySelectorAll('[data-gallery-dot]').forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
    const prev = this.querySelector('[data-gallery-prev]');
    const next = this.querySelector('[data-gallery-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= count - 1;
  }
}

if (!customElements.get('s-launch-gallery')) customElements.define('s-launch-gallery', SLaunchGallery);
